/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2013-2023 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */

/**
 * @namespace Phaser.Utils.Array.Matrix
 */

module.exports = {

    CheckMatrix: require('./CheckMatrix'),
    MatrixToString: require('./MatrixToString'),
    ReverseColumns: require('./ReverseColumns'),
    ReverseRows: require('./ReverseRows'),
    Rotate180: require('./Rotate180'),
    RotateLeft: require('./RotateLeft'),
    RotateMatrix: require('./RotateMatrix'),
    RotateRight: require('./RotateRight'),
    Translate: require('./TranslateMatrix'),
    TransposeMatrix: require('./TransposeMatrix')

};
